import api from './api';
import type {
  GradeFeePricingSchema,
  UpsertGradeFeePricingPayload,
  GradeFeePricingFilter,
} from '@/types/grade_fee_pricing_schema';

export const gradeFeePricingApi = {
  async list(filter: GradeFeePricingFilter = {}): Promise<GradeFeePricingSchema[]> {
    const params: Record<string, string> = {};
    if (filter.grade_id) params.grade_id = String(filter.grade_id);
    if (filter.fee_type_id) params.fee_type_id = String(filter.fee_type_id);
    if (filter.branch_id) params.branch_id = filter.branch_id;
    if (filter.academic_year_id) params.academic_year_id = String(filter.academic_year_id);
    if (filter.active_only) params.active_only = 'true';
    const response = await api.get('/grade-fee-pricing', { params });
    return response.data.data ?? [];
  },

  async getByGrade(gradeId: number, branchId?: string): Promise<GradeFeePricingSchema[]> {
    const params: Record<string, string> = {};
    if (branchId) params.branch_id = branchId;
    const response = await api.get(`/grade-fee-pricing/grade/${gradeId}`, { params });
    return response.data.data ?? [];
  },

  async upsert(payload: UpsertGradeFeePricingPayload): Promise<GradeFeePricingSchema> {
    const response = await api.post('/grade-fee-pricing', payload);
    return response.data.data;
  },

  async remove(id: number): Promise<void> {
    await api.delete(`/grade-fee-pricing/${id}`);
  },
};

export default gradeFeePricingApi;
